import React from 'react';
import ReactDOM from 'react-dom';
import DrumMachine from './App';

ReactDOM.render(
  <DrumMachine />,
  document.getElementById('app')
  );
